import { useCallback } from "react";
import { api } from "../../api";
import type { DisplayConversation, DisplayMessage } from "./ChatPage";
import type { ChatVersionActionsContext } from "./ChatContextTypes";

export function useChatVersionActions(context: ChatVersionActionsContext) {
  const {
    conversationRef,
    setConversation,
    setDeleteTarget,
    setError,
    setSending,
    stickToBottom,
  } = context;
  const selectVersion = useCallback(
    async (message: DisplayMessage, versionId: string) => {
      const current = conversationRef.current;
      if (!current) return;
      setSending(true);
      setError("");
      stickToBottom.current = true;
      try {
        setConversation(
          await api<DisplayConversation>(
            `/conversations/${current.id}/messages/${message.id}/versions/${versionId}/select`,
            { method: "POST", body: JSON.stringify({}) },
          ),
        );
      } catch (reason) {
        setError(
          reason instanceof Error
            ? reason.message
            : "Could not switch message version",
        );
      } finally {
        setSending(false);
      }
    },
    [conversationRef, setConversation, setError, setSending, stickToBottom],
  );
  const chooseDeleteTarget = useCallback(
    (message: DisplayMessage) => setDeleteTarget(message),
    [setDeleteTarget],
  );
  return {
    selectVersion,
    chooseDeleteTarget,
  };
}
